export default {
  needHelp: {
    id: 'insights_need_help',
    defaultMessage: 'Need help?',
  },
  cantAccessDashboardGetHelp: {
    id: 'insights_cant_access_dashboard_get_help',
    defaultMessage: 'Can’t access this dashboard? {link, html}',
  },
  getHelp: {
    id: 'insights_get_help',
    defaultMessage: 'Get help',
  },
  howToReadDashboardLearnHow: {
    id: 'insights_how_to_read_dashboard_learn_how',
    defaultMessage: 'Not sure how to read this dashboard? {link, html}',
  },
  learnHow: {
    id: 'insights_learn_how',
    defaultMessage: 'Learn how',
  },
  cannotAccessDescription: {
    id: 'quality_dashboard_cannot_access_text',
    defaultMessage: 'You cannot access your dashboard? {link, html}',
  },
  cannotAccessCTA: {
    id: 'quality_dashboard_cannot_access_cta',
    defaultMessage: 'Learn more here.',
  },
}
